import { Component, ErrorHandler, OnDestroy, OnInit, ChangeDetectionStrategy, signal } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'

import { Observable, Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

import { DebugService } from 'app/_angular/service/debug.service'
import { FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'
import { KirjautunutKayttajaService } from 'app/_angular/service/kirjautunut-kayttaja.service'
import { AsiakasTagi } from 'app/_jaettu-lemonator/model/asiakas'
import { YllapitoUriService } from 'app/_jaettu-lemonator/service/yllapito-uri.service'
import { TagiDialog, TagiDialogData } from './tagi.dialog'

@Component({
  templateUrl: './tagit.component.html',
  styleUrls: ['./tagit.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TagitComponent implements OnInit, OnDestroy {
  private _ngUnsubscribe = new Subject<void>()

  readonly tagit = signal<AsiakasTagi[]>([])
  readonly loading = signal(true)

  kirjanpitajaOnDevaajaObservable: Observable<boolean>
  tagitUri: string
  tagitEncodedUri: string

  constructor(
    private _errorHandler: ErrorHandler,
    private _firebaseLemonator: FirebaseLemonator,
    private _yllapitoUriService: YllapitoUriService,
    private _dialog: MatDialog,
    private _kirjautunutKayttajaService: KirjautunutKayttajaService,
    private _debugService: DebugService,
  ) {}

  ngOnInit() {
    this.kirjanpitajaOnDevaajaObservable = this._kirjautunutKayttajaService.kirjanpitajaOnDevaajaObservable
    this.tagitUri = this._yllapitoUriService.annaAsiakasTagitCollectionUri()
    this.tagitEncodedUri = this._debugService.createFirestoreLink(this.tagitUri)

    this._firebaseLemonator
      .firestoreCollection<AsiakasTagi>(this._yllapitoUriService.annaAsiakasTagitCollectionUri())
      .listen()
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe({
        next: tagit => {
          this.tagit.set(
            (tagit || []).sort((a, b) => {
              const poistetut = (a.poistettu ? 1 : 0) - (b.poistettu ? 1 : 0)
              return poistetut || a.nimi.localeCompare(b.nimi)
            }),
          )
          this.loading.set(false)
        },
        error: err => this._errorHandler.handleError(err),
      })
  }

  ngOnDestroy() {
    this._ngUnsubscribe.next()
    this._ngUnsubscribe.complete()
  }

  lisaa() {
    const data: TagiDialogData = { tagi: null, kaikkiTagit: this.tagit() }
    this._dialog.open(TagiDialog, { data })
  }

  muokkaa(tagi: AsiakasTagi) {
    const data: TagiDialogData = { tagi: tagi, kaikkiTagit: this.tagit() }
    this._dialog.open(TagiDialog, { data })
  }
}
